<template>
    <td>
        <strong>{{ name }}</strong> 
        <p>{{ website }}</p>
    </td>
    <td>
        <span :class="['badge', getStatusClass(status)]">
            {{ status }}
        </span>
    </td>
    <td>
        <a :href="websiteUrl" class="btn btn-secondary me-2" target="_blank">Go to web portal</a>
    </td>
    
</template>


<script>
    import axios from 'axios';
    export default {
        props: {
            data: null,
        },
        data() {
            return {
                detail: null
            };
        },
        computed: {
            website() {
                return this.detail ? this.detail.plan.description.replace('.safeworkpro.com', '') + '.safeworkpro.com' : 'Loading...';
            },
            websiteUrl() {
                return this.detail ? 'https://' +  this.detail.plan.description.replace('.safeworkpro.com', '') + '.safeworkpro.com' : 'Loading...';
            },

            name() {
                return this.detail ? this.detail.plan.name : 'Loading...';
            },
            status() {
                return this.detail ? this.detail.status : 'Loading...';
            }
        },
        created() {
            this.fetchSubscriptionDetail();
        },
        methods: {
            fetchSubscriptionDetail() {
                if(this.data != undefined){
                    axios.get('/api/zoho/subscription/' + this.data)
                    .then(response => {
                        let data = response.data.subscription;
                        this.detail = data;
                    })
                    .catch(() => {
                        this.error = 'Not found';
                    })
                    .finally(() => {
                        this.loading = false;
                    });
                }
                
            },
            getStatusClass(status) {
                //live, trial, dunning, unpaid, non_renewing, cancelled, creation_failed, cancelled_from_dunning, expired, trial_expired or future
                let bg = 'danger';
                if(status == 'live')
                    bg = 'info';
                if(status == 'trial')
                    bg = 'warning';

                return 'bg-label-' + bg.toLowerCase();
            }
        },
    };

</script>

